<template>
    <div v-show="list.length!=0" class="aside-1">
        <dl>
            <div class="title">
                <i></i>{{title}}
                <div class="rankType" >
                <a @click='getRewen("day")'>日排行</a><a @click='getRewen("week")'>周排行</a><a @click='getRewen("month")'>月排行</a>
                </div>
            </div>
        </dl>
        <dd v-for="(item,index) in list" :key="index">
            <div :style="{color:index<3?'#3dabfe':'#666666'}">{{topNumber[index]}}</div>
            <a :href="item.open_type==0?`/news/${item.id}`:item.third_url">{{item.title}}</a>
            <span>{{friendlyTime(item.released_at)}}</span>
        </dd>
        <span></span>
    </div>
</template>
<script>
    import friendlyTime from 'asset/js/utils/friendlyTime';
    import Vue from 'vue';
    import VueLazyload from 'vue-lazyload';
    import axios from 'asset/news-pc/js/axios.js';
    import api from 'asset/news-pc/js/api.js';
    Vue.use(VueLazyload, {
        error: '/public/w/img/wap/loading.png',
        loading: '/public/w/img/wap/loading.png',
    });
    export default {
        props: ['title', 'list'],
        data() {
            return {
                topNumber: ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨', '⑩'],
                friendlyTime
            }
        },
        mounted() {
            this.getRewen('day')
        },
        methods: {
            getRewen(type) {
                axios.get(`${api.rewen}?pagesize=10&&type=${type}`).then(data => {
                this.list = data.data.data.items;
            });
        }

         },
        components: {}
    };
</script>
<style scoped>
.rankType{
    float: right;
    margin-left:  20px;
    cursor: pointer;
    font-size: 30px;
    color:  #888;
}
.rankType a{ 
display: inline-block;
margin-right: 20px;
}
</style>


// WEBPACK FOOTER //
// app/web/component/web/news-aside/ranking-aside.vue